"use client";

import React from "react";
import { Sparkles, Droplets, House, Clock, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const services = [{
  title: "Land Transfer Tax",
  description: "Estimate the provincial and municipal land transfer taxes for your next Ontario property purchase.",
  icon: Droplets,
  href: "/LandTransferPage"
}, {
  title: "Rent Increase Tool",
  description: "Determine the maximum legal rent increase allowed under Ontario's annual guideline for residential units.",
  icon: House,
  href: "/RentIncreasePage"
}, {
  title: "HST Calculator",
  description: "Instantly add or remove Ontario's 13% Harmonized Sales Tax from any amount with precision and speed.",
  icon: Sparkles,
  href: "/HstCalculatorPage"
}, {
  title: "TFSA Room Planner",
  description: "Calculate your total contribution room based on your eligibility year and historical CRA limit data.",
  icon: Clock,
  href: "/TfsaPlannerPage"
}];
export default function ServicesGrid() {
  return <section data-section-id="253663" id="select-your-calculator" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tighter mb-4 text-foreground">
            Precision Tools for Ontario
          </h2>
          <p className="text-lg text-muted-foreground">
            OntarioCalc offers a range of specialized calculators
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, i) => <Link key={i} to={service.href} data-index={i} className="block h-full group/card">
              <Card className="bg-card border-border/60 group-hover/card:border-primary group-hover/card:shadow-xl group-hover/card:-translate-y-2 transition-all duration-200 flex flex-col h-full rounded-md">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 text-primary">
                    <service.icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <CardTitle className="font-default text-xl font-bold tracking-tight text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <div className="text-primary font-mono font-semibold text-xs uppercase tracking-widest group-hover/card:text-primary/80 transition-colors flex items-center gap-1">
                    Execute Calculation
                    <ChevronRight className="w-4 h-4 group-hover/card:translate-x-1 transition-transform" />
                  </div>
                </CardFooter>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}